// Because Android
export const ANDROID_VALIDATION_ICON_CONTAINER_OFFSET = 5;
export const ANDROID_HORIZONTAL_PADDING_OFFSET = 8;
export const ANDROID_DEFAULT_PADDING = 0;
export const ALLOW_FONT_SCALING = true;
export const ADJUSTS_FONT_SIZE_TO_FIT = true;
export const MAX_FONT_SIZE_MULTIPLIER = 3;